/**
 * @author sudong.duan
 * Date: 21-12-16
 * desc: axios请求方法
 */

import axios from 'axios'
import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast);
 import { isEmpty } from './common'
 //import { removeAccountInfoStorage, removeTokenStorage } from './storage'
 
 
 
let baseUrl = ''
const protocol = window.location.protocol ? window.location.protocol : 'http:'
if (process.env.NODE_ENV === 'development') {
    baseUrl = `${protocol}//api-live-test.medlander.com`
} else if (process.env.NODE_ENV === 'pre') {
    baseUrl = `${protocol}//api-live-test.medlander.com`
} else if (process.env.NODE_ENV === 'production') {
    baseUrl = `${protocol}//api-live-prod.medlander.com`
} else {
	baseUrl = `${protocol}//api-live-test.medlander.com`
}
 
const responseCode =  {
    /**
     * 请求成功
     */
    success: 200,
    /**
     * token失效
     */
    tokenFailure: 201
}
 
 
 //请求前拦截
 axios.interceptors.request.use(
	 (config) => {
		 if (config.url.indexOf('http://') === -1 && config.url.indexOf('https://') === -1) {
			 config.url = baseUrl + config.url
		 }
		 config.transformResponse = [(data) => {
			 return JSON.parse(data)
		 }]
 
		 return config
	 },
	 (error) => {
		 return error
	 }
 )
 
 //请求返回拦截
 axios.interceptors.response.use(
	 (response) => {
		 try {
			 if (response) {
				 const result = response
				 return result
			 }
		 } catch (err) {
			 //window.$message.error(err)
			 return {}
		 }
	 },
	 (error) => {
		 if (error.response) {
			 return error.response
		 }
	 }
 )
 
 export const requestApi = (params) => {
	 return new Promise((resolve, reject) => {
		 axios.post(params.url, params.data, { headers: Object.assign({ "Content-Type": "application/json" }, params.headers || {})})
			 .then((res) => {
				 if (isEmpty(res) || isEmpty(res.data)) {
					 Toast('网络请求失败，请稍后再试')
					 return
				 }
				 if (res.data.code === responseCode.success) {
					 resolve(res.data)
				 } else if (res.data.code === responseCode.tokenFailure) {
					Toast(res.data.note)
					 //window.location.href = '/'
				 } else {
					 if (params.isDefault) {
						 
					 }
					 if (!params.hideNote) {
						Toast(res.data.note)
					 }
					 reject(res.data)
				 }
			 })
	 })
 }
 
 //export { axios }


// WEBPACK FOOTER //
// ./src/utils/axios.js